/**
 * Safe localStorage JSON helpers. All persisted console state uses VERSIONED
 * keys (e.g. 'sg.auth.v1') so a future shape change can ignore stale data
 * instead of crashing on it. Failures (quota, disabled storage, bad JSON)
 * are silent by design — persistence is best-effort, never load-bearing.
 *
 * Security note (01-architecture.md §7): the bearer token lives in
 * localStorage, an accepted XSS exposure inherited from pos-browser. Do not
 * widen what is persisted beyond the documented auth snapshot.
 */

export function loadJson<T>(key: string): T | null {
  try {
    const raw = localStorage.getItem(key);
    return raw ? (JSON.parse(raw) as T) : null;
  } catch {
    return null;
  }
}

export function saveJson(key: string, value: unknown): void {
  try {
    localStorage.setItem(key, JSON.stringify(value));
  } catch {
    // storage full/unavailable — non-fatal
  }
}

export function removeKey(key: string): void {
  try {
    localStorage.removeItem(key);
  } catch {
    // ignore
  }
}
